/**
 * The root component. All other states are injected based on routing in this components
 * router-outlet. Global componenets (agency select, header, footer) declared here.
 */

// ng
import { Component, ViewEncapsulation, OnInit, OnChanges, OnDestroy, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';

// ext
import { lastValueFrom, Subscription } from 'rxjs';
import { find, upperFirst, sortBy } from 'lodash';

// local
import { env } from 'src/env/development';
import { cloneDeep } from 'lodash';
import { SpinnerOverlayService } from 'src/app/services/spinnerOverlay.service';
import { CoreService, AccessLevel, UserTypeCode } from 'src/app/services/core.service';
import Plan from 'src/app/models/plan';
import EnrollmentPeriod from 'src/app/models/enrollmentPeriod';
import * as dayjs from 'dayjs';
import Subscriber from 'src/app/models/subscriber';
import { EnrollmentService } from 'src/app/services/enrollment.service';

@Component({
  selector: 'plan-selection',
  templateUrl: 'planSelection.component.html',
  styleUrls: [],
  providers: [],
  encapsulation: ViewEncapsulation.None,
})
export class PlanSelectionComponent implements OnInit, OnChanges, OnDestroy {
  @Input() availablePlans: Plan[];
  @Input() planType: string;
  @Input() selectedPlan: Plan;
  @Input() subscriber: Subscriber;
  @Input() isWaived = false;
  @Input() readonly = false;
  @Input() selectedPlanId: string[] = [];
  @Input() subscriberOrDependentsHaveMedicareB = false;
  @Input() memberTypeCode: string;
  @Input() medicareDEnabled = false;
  @Input() isRetireeOrCOBRA = false;
  @Input() isRetiree = false;
  @Input() enrollmentPeriod: EnrollmentPeriod;
  @Output() updateSelectedPlan: EventEmitter<Plan> = new EventEmitter<Plan>();
  @Output() removeSelectedPlan: EventEmitter<Plan> = new EventEmitter<Plan>();
  @Output() getPlans: EventEmitter<boolean> = new EventEmitter<boolean>();
  availablePlanColumns = [];
  availablePlanClone: Plan[];
  showAll = false;
  isHCAEditOrAdmin = false;
  isPebb: boolean;
  coverageYear: number;
  isNewlyEligible = false;

  constructor(
    private coreService: CoreService, private enrollmentService: EnrollmentService
  ) {}

  ngOnInit(): void {
    this.isHCAEditOrAdmin = this.coreService.systemUserHasAccess(AccessLevel.Edit, UserTypeCode.HCA);
    this.availablePlanColumns = [
      {
        field: 'planName',
        title: upperFirst(this.planType) + ' plan',
        format: 'text',
        value: (row, originalValue) => (this.medicareDEnabled && this.isRetireeOrCOBRA && row.medicareDPlanName) ? `${originalValue} or ${row.medicareDPlanName}` : originalValue
      },
      {
        field: 'rateAmt',
        title: 'Premium',
        format: 'c0'
      }
    ];
  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.enrollmentPeriod?.isFirstChange) {
      this.coverageYear = dayjs(this.enrollmentPeriod.coverageEffectiveStartDate).year();
      this.isNewlyEligible = this.enrollmentPeriod.enrollmentPeriodType.enrollmentPeriodTypeCode === 'NE';
    }

    if (changes.subscriber?.isFirstChange)
      this.isPebb = !this.subscriber.isSebb && !this.subscriber.isSelfPay;

    if (changes.availablePlans?.isFirstChange) {
      this.availablePlanClone = sortBy(cloneDeep(this.availablePlans.filter(p => p.planCode !== env.dentalWaivePlanCode)), ['sortOrder', 'planName']);

      // Accidentally started coding this here instead of current coverage page; when we want to start showing these in the wizard (when retiree redesign
      // gets going again), this is a good starter.
      // if (this.isRetiree) {
      //   // US28495 - Show rates for retirees.  Edit the if block above if we want COBRA or LWOP (rates are loaded into DB)
      //   const spRates = await lastValueFrom(this.enrollmentService.getMemberSelfPayAvailablePlans(false, this.subscriber.memberId, this.enrollmentPeriod.coverageEffectiveStartDate));
      //   // console.log('spRates', spRates);
  
      //   this.availablePlanClone.forEach(p => {
      //     let spRate = find(spRates, spr => spr.planId === p.planId);
      //     // if (spRate && spRate.rates.length > 0) p.rates.push(cloneDeep(spRate.rates[0]));
      //     if (spRate && spRate.rates.length > 0) p.rateAmt = spRate.rates[0].rateAmt;
      //   });
      // }
    }
  }

  ngOnDestroy(): void {
  }

  onPlanSelected(selectedPlan: Plan): void {
    this.updateSelectedPlan.emit(selectedPlan);
  }

  showAllChange(): void {
    this.getPlans.emit(this.showAll);
  }

  onPlanDeSelected(selectedPlan: Plan): void {
    this.removeSelectedPlan.emit(selectedPlan);
  }
}